import { authAxios as axios } from "shared-auth";
import { IJobSettings } from "shared/models/settings";

import config from "config/global";

class JobSettingsService {
  private readonly url: string;

  constructor({ url }: { url: string }) {
    this.url = url;
  }

  public async get(abortController?: AbortController): Promise<IJobSettings> {
    const response = await axios(this.url, {
      signal: abortController?.signal,
    });

    return response.data;
  }

  public async update(
    data: IJobSettings,
    abortController?: AbortController
  ): Promise<IJobSettings> {
    const response = await axios(this.url, {
      method: "put",
      data,
      signal: abortController?.signal,
    });

    return response.data;
  }
}

export const jobSettingsApiUrl = `${config.linkboardApiUrl}/settings`;

export default new JobSettingsService({
  url: jobSettingsApiUrl,
});
